import React, { useState } from "react";
import { Field } from "formik";
import {
  CsplTable as Table,
  FieldInput,
  AddPlans,
  SliderPanel,
  Link,
  FormControlSearch,
  FieldInputDollar,
  FieldInputPercentage,
  WarningModal,
} from "../../../components";
import { get, isEmpty } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";

const columns = [
  {
    label: "Investment",
    className: "column-investment",
    columnName: "investmentName",
  },
  {
    label: "Percentage",
    className: "column-percentage",
    columnName: "percentage",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

export const SameInvestmentElection = (props) => {
  const {
    isSave,
    isEdit,
    values,
    handleChange,
    investmentList,
    setToggle,
    toggle,
    autoEnrollment,
    deleteInvestment,
    planId,
    setValues,
    setFieldValue,
    errors,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState([]);
  const [searchString, setSearchString] = useState("");
  // const [saveInvestments, setSaveInvestments] = useState([]);
  let saveInvestments = !Array.isArray(
    get(values, "autoEnrollment.savedInvestments", [])
  )
    ? []
    : get(values, "autoEnrollment.savedInvestments", []);
  const [addedInvestments, setAddedInvestments] = useState(saveInvestments);
  const [sum, setSum] = useState(0);
  const handleSearchChange = (e) => {
    const val = e.target.value;
    if (val != "" && val) {
      const searchList = investmentList.filter((f) =>
        f.investmentName.toLowerCase().includes(val.toLowerCase())
      );
      return setFilteredResponse(searchList);
    }
    setFilteredResponse(investmentList);
  };
  const [modalVisible, setModalVisible] = useState(false);
  const addInvestmentsToPlan = (name) => {
    setAddedInvestments((e) => [...e, name]);
  };

  const onViewButtonClick = () => {
    setModalOpen(true);
  };

  const onSubmit = (savedInvestments) => {
    // setSaveInvestments(savedInvestments);
    setFieldValue("autoEnrollment.savedInvestments", savedInvestments);
    setModalOpen(false);
  };

  const onCancel = () => {
    if (
      addedInvestments.length !=
      get(values, "autoEnrollment.savedInvestments", []).length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  const modalOnCancel = () => {
    setAddedInvestments(saveInvestments);
    setModalOpen(false);
    setModalVisible(false);
  };

  useDeepEffect(() => {
    setFilteredResponse(
      investmentList.filter((team) => {
        return team.investmentName
          .toLowerCase()
          .includes(searchString.toLowerCase());
      })
    );
  }, [searchString, investmentList]);

  const deletefunction = (name, index) => {
    var temp = saveInvestments.filter((e) => e.investmentName !== name);
    // var temp = saveInvestments.filter((e) => e.investmentName !== name);
    setAddedInvestments(temp);
    // setSaveInvestments(temp);
    setValues({
      ...values,
      autoEnrollment: {
        ...values.autoEnrollment,
        autoEnrollmentInvestmentElections: values.autoEnrollment.autoEnrollmentInvestmentElections.filter(
          (x) => x.investmentName !== name
        ),
        savedInvestments: temp,
      },
    });
  };

  // const onDeleteClick = (name, index) => {
  //   setToggle(!toggle);
  //   // autoEnrollment.investmentDetails
  //   //   ? autoEnrollment.investmentDetails.forEach((e) =>
  //   //       e.investmentName === name
  //   //         ? deleteInvestment(planId, e.investmentId).then((response) => {
  //   //             if (response) deletefunction(name);
  //   //           })
  //   //         : deletefunction(name)
  //   //     )
  //   //   : deletefunction(name);
  //   deletefunction(name, index);
  //   setToggle(!toggle);
  // };

  const Invsum = () => {
    let sum1 = 0;
    if (
      !isEmpty(get(values, "autoEnrollment.autoEnrollmentInvestmentElections"))
    )
      values.autoEnrollment.autoEnrollmentInvestmentElections.map((x) => {
        const invPer = x?.investmentPercentage ? x?.investmentPercentage : 0;
        return (sum1 = sum1 + invPer);
      });
    return sum1;
  };
  const errorMsg = (invsum) =>
    invsum !== 100
      ? "The total value of investment election should not exceed or subceed 100%"
      : "";
  const AddName = (e, source, i) => {
    if (
      !isEmpty(
        get(values, `autoEnrollment.autoEnrollmentInvestmentElections.${i}`)
      )
    ) {
      values.autoEnrollment.autoEnrollmentInvestmentElections[
        i
      ].investmentName = source;
    }
    //if(!isEmpty(values.autoEnrollmentInvestmentElections))values.autoEnrollmentInvestmentElections=[]
    handleChange(e);
  };
  return (
    <div>
      {!isEmpty(saveInvestments) ? (
        <>
          <div className="mt-40 table-size">
            <div className="d-flex justify-content-between align-baseline">
              <p className="mt-20 plan-heading-plan">
                List of Investment Election Added
              </p>
              <Button
                variant="secondary"
                disabled={isEdit && !isSave}
                onClick={() => setModalOpen(true)}
              >
                Add Investment
              </Button>
            </div>
            <div>
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    {columns.map((item, index) => {
                      return (
                        <Table.Th
                          key={index}
                          className={(item.className, "col-md-4")}
                        >
                          {item.label}
                        </Table.Th>
                      );
                    })}
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {saveInvestments.map((source, index) => {
                    const fieldName = `autoEnrollment.autoEnrollmentInvestmentElections[${index}].investmentPercentage`;
                    return (
                      <Table.Tr key={index}>
                        <Table.Td className="column-investment col-md-4">
                          {source.investmentName}
                        </Table.Td>
                        <Table.Td className="column-percentage">
                          <Form
                            autoComplete="off"
                            className="h-100 percentage-field"
                          >
                            <Field
                              size="xs"
                              isRequired
                              name={fieldName}
                              hasSuggestion
                              shouldDisplaySuggestion
                              component={FieldInputPercentage}
                              type="number"
                              value={get(values, fieldName)}
                              onChange={(e) => {
                                AddName(e, source.investmentName, index);
                              }}
                              disabled={isEdit && !isSave}
                              autoComplete="off"
                              validate={(value) => {
                                return value === null ||
                                  value === undefined ||
                                  value === ""
                                  ? "PL545 : Required"
                                  : value === 0
                                  ? "PL546 : Allocation percentage cannot be 0"
                                  : undefined;
                              }}
                            />
                          </Form>
                        </Table.Td>
                        <Table.Td className="column-action col-md-4">
                          <Link>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              color="red"
                              onClick={() => {
                                if (!(isEdit && !isSave))
                                  deletefunction(source.investmentName, index);
                                // onDeleteClick(source.investmentName, index)
                              }}
                            />
                          </Link>
                        </Table.Td>
                      </Table.Tr>
                    );
                  })}
                </Table.Tbody>
                <div className="line-separator-total" />
                <Table.Tbody>
                  <Table.Tr>
                    <Table.Td className="column-investment col-md-4">
                      Total
                    </Table.Td>
                    <Table.Td className="column-percentage col-md-4">
                      <Form
                        autoComplete="off"
                        className="h-100 percentage-field"
                      >
                        <Field
                          size="xs"
                          isRequired
                          name="totalBox"
                          hasSuggestion
                          shouldDisplaySuggestion
                          component={FieldInputPercentage}
                          type="number"
                          value={Invsum()}
                          autoComplete="off"
                          disabled
                          validate={(value) => {
                            return Invsum() != 100 ? " " : undefined;
                          }}
                        />
                        <p
                          style={{
                            display: "block",
                            color: "#ff5050",
                            fontSize: "0.75rem",
                            marginTop: "0rem",
                          }}
                        >
                          {errorMsg(Invsum())}
                        </p>
                      </Form>
                    </Table.Td>
                  </Table.Tr>
                </Table.Tbody>
              </Table>
            </div>
          </div>
        </>
      ) : (
        <div className="mt-40">
          <p className="mt-20 plan-heading-plan">Investment Election</p>
          <AddPlans
            content="No Investments added."
            buttonLabel="Add Investment"
            disabled={isEdit && !isSave}
            onPrimaryClick={onViewButtonClick}
          />
          <p
            style={{
              display: "block",
              color: "#ff5050",
              fontSize: "0.75rem",
              marginTop: "0rem",
            }}
          >
            {get(
              errors,
              "autoEnrollment.investmentElectionSameSourceSameParticipant",
              ""
            )}
          </p>
        </div>
      )}

      <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
        <div className="inside-content">
          <div className="d-flex justify-content-between align-baseline">
            <div>
              <p className="investment-heading">Plan Investments</p>
              <p className="investment-sub-heading">
                {filteredResponse.length}{" "}
                {filteredResponse.length === 1
                  ? "Investment Available"
                  : "Investments Available"}
              </p>
            </div>
            <div>
              <Button variant="secondary" onClick={() => onCancel()}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => onSubmit(addedInvestments)}
                className="ml-4"
              >
                Save
              </Button>
            </div>
          </div>
          <div className="search-bar-investment">
            {/* <Form>
            <InputGroup>
            <FormControlSearch
                size="lg"
                id="plan-search-box"
                className="plan-search-box"
                type="search"
                autoComplete="off"
                placeholder="Search Investment"
                onChange={(e) => setSearchString(e.target.value)}
              />
              <InputGroup.Append>
                <InputGroup.Text className="plan-search-button">
                  <Image src="/assets/icons/svg/search.svg" width="14px" />
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Form> */}
            <Form>
              <InputGroup>
                <FormControlSearch
                  size="lg"
                  id="plan-search-box"
                  className="plan-search-box"
                  type="search"
                  autoComplete="off"
                  placeholder="Search Investment"
                  onChange={handleSearchChange}
                />
                {/* <InputGroup.Append>
                  <InputGroup.Text className="plan-search-button">
                    <Image src="/assets/icons/svg/search.svg" width="14px" />
                  </InputGroup.Text>
                </InputGroup.Append> */}
              </InputGroup>
            </Form>
          </div>
          <div className="d-flex content-end">
            <p className="investment-side-content">
              {filteredResponse.length}{" "}
              {filteredResponse.length === 1
                ? "Investment Available"
                : "Investments Available"}
            </p>
          </div>
          <div className="scroll-body">
            {filteredResponse &&
              filteredResponse.map((e, i) => (
                <div className="d-flex justify-content-between">
                  <p>{e.investmentName}</p>
                  {addedInvestments.find(
                    (y) => y.investmentName === e.investmentName
                  ) ? (
                    // <Button
                    //   size="sm"
                    //   style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                    //   variant="secondary"
                    //   disabled
                    //   classname="custom-added"
                    // >
                    //   Added
                    // </Button>
                    <div className="added-button-inside">
                      <div className="added-button-inner-text">Added</div>
                    </div>
                  ) : (
                    <>
                      {/* <Button
                      style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                      variant="secondary"
                      onClick={() => addInvestmentsToPlan(e)}
                    >
                      Add
                    </Button> */}
                      <div
                        className="add-button-inside"
                        onClick={() => addInvestmentsToPlan(e)}
                      >
                        <div className="add-button-inner-text">Add</div>
                      </div>
                    </>
                  )}
                </div>
              ))}
          </div>
        </div>
      </SliderPanel>
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default SameInvestmentElection;
